var mixin = require('../../../common/mixin');
var util = require('../../util/utility');
var getUA = require('../../../common/get-ua').internal;

var ua = getUA();

function noop() {}

var batchAPI = [
    'setLLButton',
    'setLRButton',
    'setRLButton',
    'setRRButton'
];

function _convertIcon(icon) {
    var mapList = {
        'H5_Favorite_On': 'ic_action_favorite_on_normal',
        'H5_Favorite_Off': 'ic_action_favorite_off_normal'
    };

    if (/android/i.test(ua.osName)) {
        return mapList[icon] || icon;
    }
    return icon;
}


var mappedAPI = batchAPI.map(function (api) {
  return {
    message: api,
    version: '9.2.0',
    mapper: function(opts){
      if (opts && opts.icon){
        opts.icon = _convertIcon(opts.icon);
      }

      return opts;
    }
  }
});

module.exports = [
  {
    version: '9.2.0',
    message: 'login',
    mapper: function (opts) {
      var self = this;
      var success = opts.success || noop
      return mixin({}, opts, {
        success: function () {
          self.getUserInfo({
            success: function (ret) {
              success(mixin({}, ret, {
                type: 'dp',
                token: ret.token || ret.userToken,
                uuid: ret.uuid
              }));
            }
          })
        }
      });
    }
  },
  {
    version: '9.2.0',
    message: 'share',
    statics: {
      WECHAT_FRIENDS: 0,
      WECHAT_TIMELINE: 1,
      QQ: 2,
      SMS: 3,
      WEIBO: 4,
      QZONE: 5,
      EMAIL: 6,
      COPY: 7
    },
    mapper: function (opts) {
      opts = mixin({}, opts);
      opts.feed = opts.channel;
      if (!(opts.feed instanceof Array)) {
        opts.feed = [opts.feed];
      }
      if (opts.feed && opts.feed.length === 1) {
        opts.shareType = opts.feed[0];
      }

      return mixin(opts, {
        feed: util.parseFeed(opts.feed),
        url: util.tidyUrlParams(opts.url)
      });
    }
  },
  {
    version: '9.2.0',
    message: 'thirdLogin',
    handler: function(opts){
      var type = opts.type;
      var url;
      switch (type){
        case 1:
          url = location.protocol + '//m.dianping.com/auth/app?ft=15&sso=true';
          break;
        case 2:
          url = location.protocol + '//m.dianping.com/auth/app?ft=6&sso=true&redir=';
          break;
        case 3:
          url = location.protocol + '//m.dianping.com/auth/app?ft=5&ssp=true&redir=';
          break;
        case 4:
          url = location.protocol + '//m.dianping.com/auth/app?ft=2&source=1&sso=true&redir=';
          break;
      }
      this.openWebview({
        url: 'dianping://loginweb?url=' + encodeURIComponent(url) + '&isFromNative=true',
      });
    }
  },
  {
    version: '9.2.0',
    message: 'setSpotlight',
    mapper: function(opts){
      if (!opts.webpageURL) {
        return;
      }
      if (!opts.scheme) {
        opts.scheme = 'dianping://web?url=' + encodeURIComponent(opts.webpageURL);
      } 
      return opts;
    }
  },
  {
    version: '9.2.0',
    message: 'publish',
    mapper: function(opts){
      var bizname = this.getBizName();
      var CONSTS = ['phoneChanged', 'AccountBindChange'];
      if (/2Native/i.test(opts.type) || ~CONSTS.indexOf(opts.action)) {
        delete opts.type;
        return opts;
      } else if (bizname) {
        opts.action = bizname + ':' + opts.action;
        delete opts.type;
        return opts;
      }else if(!bizname){
        opts.fail && opts.fail('bizname not config, please call KNB.confg({bizName: YOUR_BIZ_NAME})')
      }
    }
  }
].concat(mappedAPI);



// WEBPACK FOOTER //
// ./~/@dp/knb/compiled/titans/dp/patch/9.2.0.js